import {useId} from 'react';
import {useFormContext} from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@common-web/components/ui/form';
import {RadioGroup, RadioGroupItem} from '@common-web/components/ui/radio-group';

export function RadioField({
  name,
  label,
  options,
  description,
  className,
}: {
  name: string;
  label: string;
  options: ReadonlyArray<{value: string; label: string}>;
  description?: string;
  className?: string;
}) {
  const {control} = useFormContext();
  const labelId = useId();
  return (
    <FormField
      control={control}
      name={name}
      render={({field}) => (
        <FormItem className={className}>
          <FormLabel id={labelId}>{label}</FormLabel>
          <FormControl>
            <RadioGroup
              aria-labelledby={labelId}
              value={field.value}
              onValueChange={field.onChange}
              className='flex h-11 items-center gap-6'
            >
              {options.map((option) => (
                <label
                  key={option.value}
                  className='flex cursor-pointer items-center gap-2 text-sm'
                >
                  <RadioGroupItem
                    value={option.value}
                    className='border-neutral-400 text-[var(--enroll-primary)] [&_svg]:fill-[var(--enroll-primary)]'
                  />
                  {option.label}
                </label>
              ))}
            </RadioGroup>
          </FormControl>
          {description && (
            <FormDescription className='text-xs text-neutral-500'>{description}</FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
